export const PAGES_TO_INCLUDE_FOR_CHECKOUT_COM = [
  '/checkout/payment',
  '/pages/subscription-payment',
  '/payment/3ds',
  '/account/register/flow',
];
